import type { App } from 'vue'
import { CARRIERS_NAMES } from '@/consts/Carriers'

export function hexToRGBA(h: string, opacity = 1) {
  let r = '0'
  let g = '0'
  let b = '0'

  // 3 digits
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`
    g = `0x${h[2]}${h[2]}`
    b = `0x${h[3]}${h[3]}`

    // 6 digits
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`
    g = `0x${h[3]}${h[4]}`
    b = `0x${h[5]}${h[6]}`
  }

  return `rgba(${+r},${+g},${+b},${opacity})`
}

export const capitalizeFilter = (value: string) => (value ? value.toUpperCase() : value)
export const capitalizeFirstLetter = (value: string) => (value ? value.charAt(0).toUpperCase() + value.slice(1) : value)
export const carrierName = (value: string) => CARRIERS_NAMES[value] || value

export const uniqueStrings = (values: Array<string | null | undefined>): string[] => {
  const seen = new Set<string>()

  return values.filter((value): value is string => {
    if (!value) {
      return false
    }

    const normalizedValue = value.trim().toLocaleLowerCase()
    if (!normalizedValue || seen.has(normalizedValue)) {
      return false
    }

    seen.add(normalizedValue)
    return true
  })
}

export const none = () => {}

export const setupApp = async (app?: App) => {
  try {
    const baseUrl = import.meta.env.VITE_CDN_URL ? import.meta.env.VITE_CDN_URL : ''

    const response = await fetch(baseUrl + '/version.txt', { cache: 'no-store' })
    const latestVersion = await response.text()
    const currentVersion = localStorage.getItem('app-version')

    if (latestVersion && currentVersion !== latestVersion) {
      localStorage.setItem('app-version', latestVersion)
      window.location.reload()
    } else {
      app?.mount('#app')
    }
  } catch {
    app?.mount('#app')
  }
}

export const mapCountryToLanguage = (countryCode: string): string => {
  const map: Record<string, string> = {
    fi: 'fi',
    se: 'sv',
  }

  return map[countryCode.toLowerCase()] || 'en'
}

// Country name in the page language ("SE" -> "Sverige" in Swedish); the API's English name if the code is unknown
export const countryName = (countryCode: string | null | undefined, fallback: string, locale: string): string => {
  if (!countryCode) return fallback
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode.toUpperCase()) || fallback
  } catch {
    return fallback
  }
}
